/* Approved bulk unit prices, USD; checkout still uses actual Shopify variants. */
(function(root){
const rates={cocktail:{foil:[30,20],print:[18,12]},luncheon:{foil:[35,30],print:[20,15]}};
function valid(q){return Number.isSafeInteger(q)&&q>=50&&q%50===0;}
function total(points,q,size,finish){
 if(!valid(q))return null;
 const tier=rates[size]?.[finish==='print'?'print':'foil'];if(!tier)return null;
 const rows=points.map(p=>({q:Number(p.q),price:Number(p.price)})).filter(p=>p.q<5000&&Number.isFinite(p.price));
 rows.push({q:5000,price:5000*tier[0]},{q:10000,price:10000*tier[1]});rows.sort((a,b)=>a.q-b.q);
 if(q>=10000)return Math.round(q*tier[1]);
 const exact=rows.find(p=>p.q===q);if(exact)return exact.price;
 const lo=rows.filter(p=>p.q<q).pop(),hi=rows.find(p=>p.q>q);if(!lo||!hi)return null;
 const unit=lo.price/lo.q+(hi.price/hi.q-lo.price/lo.q)*(q-lo.q)/(hi.q-lo.q);
 return Math.round(unit*q);
}
root.MotifQuantity={valid,total,rates};if(typeof module!=='undefined')module.exports=root.MotifQuantity;
})(typeof window!=='undefined'?window:globalThis);
